import { render, staticRenderFns } from "./fieldsTable.vue?vue&type=template&id=4bff047c"
import script from "./fieldsTable.vue?vue&type=script&lang=js"
export * from "./fieldsTable.vue?vue&type=script&lang=js"
import style0 from "./fieldsTable.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports